import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { useFormContext } from "react-hook-form";
import { Button, Popin, Text } from "$components";
import CField from "$forms/CField";
import CompanySelect from "$forms/CompanySelect";
import { useDockyardFormContext } from "../context/DockyardFormContext";
import EntrepriseForm from "$containers/Entreprises/EntrepriseForm";
import { CompanyType } from "$types";
import { useDockyardStyles } from "../styles";
import useAuth from "$hooks/useAuth";

export const InterveningCompaniesSection: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const classes = useDockyardStyles();
  const { isAdmin } = useAuth();

  const {
    currentCompany,
    contributorOptions,
    isIntervenantOpened,
    toggleIntervenantPopin,
    handleSubmitIntervenant,
    companyError,
    intervenantSubmitting,
    dockyard,
  } = useDockyardFormContext();

  return (
    <>
      <div className="bordered">
        <Text type="h3">Entreprise(s) intervenante(s)</Text>
      </div>
      <div
        className={classes.newFormFieldsRow}
        style={{ alignItems: "center" }}
      >
        <CField
          control={control}
          disabled={!currentCompany}
          name="interveningCompany"
          error={errors.interveningCompany}
        >
          {(props) => (
            <CompanySelect
              {...props}
              multiple
              companyOptions={contributorOptions}
              placeholder="Sélectionnez des entreprises intervenantes"
              label="Entreprise(s)"
              ignoreSideBarCompanyFilter
              companyTypes={[CompanyType.CONTRIBUTOR]}
              minCharsToTrigerSearch={0}
              rowsPerPage={99999}
            />
          )}
        </CField>
        {isAdmin() && (
          <Button
            color="secondary"
            variant="contained"
            onClick={() => toggleIntervenantPopin(true)}
            style={{
              padding: 0,
              minWidth: 40,
              marginLeft: 4,
              height: 34,
              marginTop: 21,
            }}
          >
            <AddIcon />
          </Button>
        )}
      </div>
      <div style={{ height: 20 }} />

      <Popin
        openPopin={isIntervenantOpened}
        toggleDrawer={toggleIntervenantPopin}
      >
        <EntrepriseForm
          readOnlyFields={["contributorOf", "companyTypes"]}
          defaultValues={{
            companyTypes: [CompanyType.CONTRIBUTOR],
            contributorOf: [dockyard?.company || currentCompany],
          }}
          onSubmit={handleSubmitIntervenant}
          onReset={() => toggleIntervenantPopin(false)}
          companyError={companyError}
          isSubmitting={intervenantSubmitting}
        />
      </Popin>
    </>
  );
};
